module.exports = __webpack_public_path__ + "img/image13.1a92a565.png";